// extracted by mini-css-extract-plugin
module.exports = {"size_modal":"ProviderPickStockImport_size_modal__sAG7G"};